import { Component ,OnInit} from '@angular/core';
import { ActivatedRoute,Router } from '@angular/router';

import { AppRoutingModule } from 'src/app/app-routing.module';
import { DataService } from '../../../../shared/data/data.service';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';

import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common'; // Import CommonModule
//import { ErrorMessageComponent } from './error-message/error-message.component';
// import { GlobalsService } from '../globals.service';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-reset-password-page',
  templateUrl: './reset-password-page.component.html',
  styleUrls: ['./reset-password-page.component.scss']
})
export class ResetPasswordPageComponent implements OnInit {
  public routes = AppRoutingModule;
  resetForm: FormGroup;
  token: string = '';
  uid: string = '';
  message: string = '';
  status: number | null = null;
  isLoading = false;

  constructor(
    public data: DataService,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private http: HttpClient,
    private router: Router
  ) {
    this.resetForm = this.fb.group({
      password: [
        '',
        [
          Validators.required,
          Validators.pattern(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?#&])[A-Za-z\d@$!%*?#&]{10,}$/)
        ]
      ],
      confirmPassword: ['', Validators.required]
    }, { validators: this.passwordsMatchValidator });
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      this.token = params['token'];
      this.uid = params['uid'];
    });
  }

  passwordsMatchValidator(form: FormGroup) {
    const password = form.get('password')?.value;
    const confirmPassword = form.get('confirmPassword')?.value;
    if (password && confirmPassword && password !== confirmPassword) {
      form.get('confirmPassword')?.setErrors({ mismatch: true });
      return { mismatch: true };
    }
    return null;
  }

  onSubmit(): void {
    if (this.resetForm.invalid) return;

    this.isLoading = true;

    const { password } = this.resetForm.value;
    const payload = {
      uid: this.uid,
      token: this.token,
      password: password
    };

    this.http.post<{ status: number; message: string }>(this.data.base_url + 'reset_password/', payload).subscribe({
      next: (res) => {
        this.message = res.message;
        this.status = res.status;
        if (res.status === 1) {
          setTimeout(() =>   this.router.navigate(['/profile-authentication']), 2000);
        }
      },
      error: () => {
        this.message = 'Something went wrong.';
        this.status = 2;
      },
      complete: () => {
        this.isLoading = false;
      }
    });
  }


}
